import { useConfigContext } from '#src/contexts/config/index.ts';

export const useEnabledWheelByRarity = () => {
  const { wheel } = useConfigContext();

  return {
    limited: wheel.limitedWheelConfig !== null,
    common: wheel.commonWheelConfig !== null,
  };
};
